import styled from "styled-components";

export const AboutSection = styled.section`
  background: linear-gradient(135deg, #0f172a, #1e293b);
  padding: 100px 5%;
  display: flex;
  justify-content: center;

  .container {
    max-width: 1100px;
    display: flex;
    align-items: center;
    gap: 60px;
    flex-wrap: wrap;
  }

  .image-wrapper {
    flex: 1;
    display: flex;
    justify-content: center;

    img {
      width: 280px;
      height: 280px;
      object-fit: cover;
      border-radius: 20px;
      border: 3px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
      transition: 0.4s ease;
    }

    img:hover {
      transform: translateY(-10px);
    }
  }

  .content {
    flex: 1.5;
    color: #e2e8f0;

    .tag {
      background: #38bdf8;
      color: #0f172a;
      padding: 6px 14px;
      font-size: 14px;
      border-radius: 50px;
      font-weight: 600;
      display: inline-block;
      margin-bottom: 20px;
    }

    h2 {
      font-size: 42px;
      margin-bottom: 20px;
      color: #ffffff;
      line-height: 1.2;
    }

    p {
      font-size: 18px;
      line-height: 1.8;
      margin-bottom: 15px;
      color: #cbd5e1;
    }

    strong {
      color: #38bdf8;
    }
  }

  @media (max-width: 768px) {
    .container {
      flex-direction: column;
      text-align: center;
    }

    .content h2 {
      font-size: 32px;
    }

    .image-wrapper img {
      width: 220px;
      height: 220px;
    }
  }
`;